import request from '@/utils/request'

/**
 * 根据id删除
 * @param {*} id
 */
export function del(id) {
    return request({
        url: `/bsCredentials/delete/${id}`,
        method: 'delete'
    })
}
/**
 * 添加
 */
export function add(params) {
    return request({
        url: `/bsCredentials/save`,
        method: 'post',
        data: params
    })
}
/**
 * 修改
 */
export function edit(params) {
    return request({
        url: `/bsCredentials/update`,
        method: 'put',
        data: params
    })
}
/**
 * 根据id查询
 */
export function getInfo(id) {
    return request({
      url: `/bsCredentials/${id}`,
      method: 'get'
    })
  }